<woa-modal-page-layout [customGeometry]="customGeometry()" [title]="title()"
                       [translationParams]="{'storeName': orderingContext()?.selectedStore?.collectiveStoreName}">
    @if (showStoreHeader()) {
        <div class="store-header" woa-responsive slot="header">
            @if (showAddressSearchInHeader()) {
                <woa-location-search-panel class="store-header-address-search" woa-responsive
                                           [ngClass]="{'with-order-type-options': showStoreOrderTypeOptions()}"
                                           id="location-search-input"
                                           [accuracy]="position()?.coords?.accuracy"
                                           [latitude]="position()?.coords?.latitude"
                                           [longitude]="position()?.coords?.longitude"
                                           (onSelect)="locationSelected($event)"></woa-location-search-panel>
            }
            @if (showDeliveryAddressInHeader() || deliveryAddressError()) {
                <div class="store-header-delivery-address" woa-responsive
                    [ngClass]="{'with-order-type-options': showStoreOrderTypeOptions()}">
                    @if (showDeliveryAddressInHeader()) {
                        <div class="store-header-delivery-address-title">
                            <div class="store-header-delivery-address-title-label">
                                {{ 'woa.label.ordering-context.deliveringTo' | translate }}
                            </div>
                            <woa-link class="store-header-delivery-address-title-link" id="delivery-address-change-link"
                                      [link]="'woa.button.ordering-context.changeDeliveryAddress'"
                                      (onActivate)="editDeliveryAddress()"></woa-link>
                        </div>
                        <div class="store-header-delivery-address-details" woa-activatable
                             (onActivate)="editDeliveryAddress()">
                            <div class="store-header-delivery-address-details-text">
                                {{ formattedDeliveryAddress() }}
                            </div>
                            <woa-icon-button class="store-header-delivery-address-details-action"
                                             [type]="IconButtonType.CLOSE"
                                             (onActivate)="clearDeliveryAddress()"></woa-icon-button>
                        </div>
                    }
                    @if (deliveryAddressError()) {
                        <woa-content-message class="store-header-delivery-address-error"
                                             [level]="MessageLevel.ERROR" [text]="deliveryAddressError()"
                                             [translationParams]="{'storeName': addressErrorStore()?.collectiveStoreName}"></woa-content-message>
                    }
                </div>
            }
            @if (showStoreOrderTypeOptions()) {
                <div class="store-header-options" woa-responsive>
                    @if (canOrderAhead() && orderType() !== OrderType.ORDER_AHEAD) {
                        <woa-link [link]="'woa.button.ordering-context.show-store-type.orderAhead'"
                                  (onActivate)="changeOrderType(OrderType.ORDER_AHEAD)"></woa-link>
                    }
                    @if (canOrderDelivery() && orderType() !== OrderType.ORDER_DELIVERY) {
                        <woa-link [link]="'woa.button.ordering-context.show-store-type.delivery'"
                                  (onActivate)="changeOrderType(OrderType.ORDER_DELIVERY)"></woa-link>
                    }
                    @if (canOrderAtTable() && orderType() !== OrderType.ORDER_AT_TABLE) {
                        <woa-link [link]="'woa.button.ordering-context.show-store-type.orderAtTable'"
                                  (onActivate)="changeOrderType(OrderType.ORDER_AT_TABLE)"></woa-link>
                    }
                </div>
            }
        </div>
    }
    @if (loadingStatus() === LoadingStatus.FAILED && !storeSearchModel.dataSignal()?.length) {
        <woa-content-message [level]="MessageLevel.ERROR" [text]="'woa.error.common.loadFailed'"
                             [link]="'woa.button.common.reload'" (onLinkActivate)="load()"></woa-content-message>
    }
    @if (loadingStatus() === LoadingStatus.LOADED && showTableOptions()) {
        <woa-form class="table-search" slot="header" (onSubmit)="selectTable()">
            @if (!this.orderingContextModel.singleStoreLocation()) {
                <div class="table-search-store-filter">
                    @if (this.orderingContext()?.selectedStore) {
                        <div class="table-search-store-filter-store">
                            {{ orderingContext()?.selectedStore.collectiveStoreName }}
                        </div>
                    } @else {
                        <woa-link class="table-search-store-filter-link select"
                                  [link]="'woa.button.ordering-context.selectStore'"
                                  (onActivate)="tableFilterSelectStore()"></woa-link>
                    }
                    @if (this.orderingContext()?.selectedStore) {
                        <woa-link class="table-search-store-filter-link change"
                                  [link]="'woa.button.common.change'"
                                  (onActivate)="tableFilterSelectStore()"></woa-link>
                    }
                    @if (this.orderingContext()?.selectedStore) {
                        <woa-link class="table-search-store-filter-link show-all"
                                  [link]="'woa.button.ordering-context.showAll'"
                                  (onActivate)="tableFilterClearStore()"></woa-link>
                    }
                </div>
            }
            <woa-decimal-field class="table-search-number-filter"
                               [(ngModel)]="manualTableCode"
                               (ngModelChange)="filterTableOptions()"
                               [noMessage]="true"
                               [placeholder]="'woa.label.ordering-context.searchTableNumber'"
                               [maxlength]="'10'" [spellcheck]="false"></woa-decimal-field>
        </woa-form>
    }
    @if (loadingStatus() === LoadingStatus.LOADED && showOrderTypeSelection()) {
        <woa-order-type-selection-panel class="order-type-selection"
                                        [intention]="orderingContext()?.intention"
                                        [canOrderAtTable]="canOrderAtTable()"
                                        [canOrderAhead]="canOrderAhead()"
                                        [canOrderDelivery]="canOrderDelivery()"
                                        (onOrderTypeSelected)="orderTypeSelected($event)"></woa-order-type-selection-panel>
    }
    @if (loadingStatus() === LoadingStatus.LOADED && showTableOptions()) {
        <div class="table-selection">
            @if (tableLookupCodeMsg()) {
                <woa-content-message [level]="MessageLevel.INFO"
                                     [text]="tableLookupCodeMsg()"></woa-content-message>
            }
            @if (filteredTableOptions().length > 0) {
                <div class="table-selection-options">
                    @for (table of filteredTableOptions(); track table) {
                        <woa-button [prominence]="ButtonProminence.LOW"
                                    [overrideOutlineForegroundColor]="true"
                                    [overrideOutlineBorderColor]="true"
                                    [layout]="ButtonLayout.VERTICAL"
                                    [style]="ButtonStyle.OUTLINE"
                                    [shape]="ButtonShape.ROUNDED"
                                    (onActivate)="selectTable(table.tableLookupCode)">{{ table.tableLookupCode }}</woa-button>
                    }
                </div>
            }
        </div>
    }
    @if (loadingStatus() === LoadingStatus.LOADED && showTableSelection() && !showTableOptions()) {
        <div class="table-entry">
            @if (tableSelectionMethod() === TableLookupMethod.MANUAL) {
                <woa-form (onSubmit)="acceptTableCode()">
                    @if (allowAlphaTableNumbers()) {
                        <woa-text-field [(ngModel)]="manualTableCode" name="manualTableCode"
                                        [label]="'woa.label.ordering-context.enterTableNumber'"
                                        required [maxlength]="'10'" [spellcheck]="false"
                                        (ngModelChange)="tableLookupCodeMsg.set(undefined)"></woa-text-field>
                    } @else {
                        <woa-decimal-field [(ngModel)]="manualTableCode" name="manualTableCode"
                                           [label]="'woa.label.ordering-context.enterTableNumber'"
                                           required [maxlength]="'10'" [spellcheck]="false"
                                           (ngModelChange)="tableLookupCodeMsg.set(undefined)"></woa-decimal-field>
                    }
                    @if (tableLookupCodeMsg()) {
                        <woa-content-message [level]="MessageLevel.ERROR"
                                             [text]="tableLookupCodeMsg()"
                                             [translationParams]="{'lookupCode': tableLookupCode()}"></woa-content-message>
                    }
                </woa-form>
            } @else if (tableSelectionMethod() === TableLookupMethod.QR_CODE) {
                @if (!tableLookupCodeMsg() && !scannerMsg()) {
                    <woa-content-message [text]="'woa.message.ordering-context.scanTable'"></woa-content-message>
                }
                @if (tableLookupCodeMsg()) {
                    <woa-content-message [level]="MessageLevel.ERROR"
                                         [text]="tableLookupCodeMsg()"
                                         [translationParams]="{'lookupCode': tableLookupCode()}"></woa-content-message>
                }
                @if (scannerMsg()) {
                    <woa-content-message [level]="MessageLevel.ERROR"
                                         [text]="scannerMsg()"></woa-content-message>
                }
                @if (scannerAvailable()) {
                    <div class="table-entry-qr">
                        <div class="table-entry-qr-container">
                            <zxing-scanner #scanner
                                           [tryHarder]="true"
                                           (camerasFound)="camerasFound($event)"
                                           (camerasNotFound)="camerasNotFound($event)"
                                           (permissionResponse)="permissionResponse($event)"
                                           (scanError)="scanError($event)"
                                           (scanComplete)="scanComplete($event)"></zxing-scanner>
                            @if (scanning()) {
                                <div class="table-entry-qr-container-guideline"
                                     [ngClass]="{'highlight': showCodeScanned()}">
                                    <div class="table-entry-qr-container-guideline-topleft"></div>
                                    <div class="table-entry-qr-container-guideline-topright"></div>
                                    <div class="table-entry-qr-container-guideline-bottomleft"></div>
                                    <div class="table-entry-qr-container-guideline-bottomright"></div>
                                </div>
                            } @else {
                                <woa-spinner class="table-entry-qr-container-spinner"></woa-spinner>
                            }
                        </div>
                    </div>
                }
            }
        </div>
    }
    @if (loadingStatus() === LoadingStatus.LOADED && showStoreSelection()) {
        @if (showDeliveryAddressEntry()) {
            <woa-form class="delivery-address-entry"
                      (onSubmit)="confirmDeliveryAddress()">
                <woa-text-field [(ngModel)]="street" name="street"
                                [label]="'woa.label.address.street'"
                                required [maxlength]="'60'" [autocomplete]="'street-address'" [spellcheck]="false"
                                (ngModelChange)="deliveryDetailsChanged()"></woa-text-field>
                <woa-text-field [(ngModel)]="city" name="city"
                                [label]="'woa.label.address.suburb'"
                                required [maxlength]="'30'" [autocomplete]="'address-level2'" [spellcheck]="false"
                                (ngModelChange)="deliveryDetailsChanged()"></woa-text-field>
                <woa-field-pair>
                    <woa-text-field [(ngModel)]="state" name="state"
                                    [label]="'woa.label.address.state'"
                                    required [maxlength]="'35'" [autocomplete]="'address-level1'"
                                    [spellcheck]="false"
                                    (ngModelChange)="deliveryDetailsChanged()"></woa-text-field>
                    <woa-text-field [(ngModel)]="postCode" name="postCode"
                                    [label]="'woa.label.address.postCode'"
                                    [required]="configurationModel.app()?.integratedDelivery" [maxlength]="'10'"
                                    [autocomplete]="'postal-code'" [spellcheck]="false"
                                    (ngModelChange)="deliveryDetailsChanged()"></woa-text-field>
                </woa-field-pair>
                @if (configurationModel.app()?.showPhoneNumberForDelivery) {
                    <woa-phone-number-field [(ngModel)]="orderMobilePhone" name="orderMobilePhone"
                                            [label]="'woa.label.common.mobile'" woa-phone-number
                                            (ngModelChange)="deliveryDetailsChanged()"></woa-phone-number-field>
                }
                <woa-text-area-field [(ngModel)]="deliveryInstructions" name="deliveryInstructions"
                                     [label]="'woa.label.address.deliveryInstructions'"
                                     [maxlength]="'255'"></woa-text-area-field>
                @if (!identityModel.isGuestUser() && identityModel.currentMember().allowProfileEdit) {
                    <woa-selector-control [(selected)]="saveForMember"
                                          (selectedChange)="saveDeliveryAddressForMemberChanged()"
                                          [label]="addressMatchesMember() ? 'woa.label.address.matchesMember' : 'woa.label.address.saveForMember'"
                                          [disabled]="addressMatchesMember()"></woa-selector-control>
                }
            </woa-form>
        }
        @if (showMessageTableOrderingNotAvailableNearestStore()) {
            <woa-content-message class="table-ordering-message"
                                 [text]="'woa.message.ordering-context.tableOrderingNotAvailableNearestStore'"
                                 [translationParams]="{store: nearestStoreName()}"></woa-content-message>
        }
        @if (showNearestStores()) {
            @let filteredNearestStores = filteredStores()(storeSearchModel.nearestStores());
            <div class="stores" [class.minimal]="configurationModel.isWaiterActor()">
                @for (store of filteredNearestStores; track store.storeId) {
                    <woa-store-details-panel class="stores-store"
                                             [store]="store"
                                             [collapseText]="collapseStoreText()"
                                             [showStoreImage]="showStoreImage()"
                                             [showAddress]="configurationModel.app()?.showStoreAddrOnStoreSelection"
                                             [showDescription]="configurationModel.app()?.showStoreDescOnStoreSelection"
                                             [intention]="orderingContext()?.intention"
                                             [filteredOrderType]="orderType()"
                                             (onStoreDetails)="showStoreDetails(store)"
                                             (onOrderFromStore)="selectContext(store, $event)"></woa-store-details-panel>
                }
                @if (!filteredNearestStores.length) {
                    @if (showDeliveryAddressInHeader()) {
                        <woa-content-message class="stores-no-stores" id="no-nearest-delivery-message"
                                             [text]="'woa.message.ordering-context.noDeliveryStore'"></woa-content-message>
                    } @else if (location()) {
                        <woa-content-message class="stores-no-stores" id="no-nearest-to-location-message"
                                             [text]="'woa.message.ordering-context.noNearestToLocation'"></woa-content-message>
                    } @else {
                        <woa-content-message class="stores-no-stores" id="no-nearest-message"
                                             [text]="noStoresInLocationMessage()"></woa-content-message>
                    }
                }
            </div>
        }
        @if (showAllStores()) {
            @let filteredAllStores = filteredStores()(storeSearchModel.dataSignal());
            <div class="stores">
                @for (stateStores of filteredAllStores | groupBy: 'state'; track stateStores.key) {
                    @for (store of stateStores.value; track store.storeId) {
                        <woa-store-details-panel class="stores-store"
                                                 [store]="store"
                                                 [collapseText]="collapseStoreText()"
                                                 [showStoreImage]="showStoreImage()"
                                                 [showStateWithName]="showStateWithName()"
                                                 [showDistance]="false"
                                                 [showAddress]="configurationModel.app()?.showStoreAddrOnStoreSelection"
                                                 [showDescription]="configurationModel.app()?.showStoreDescOnStoreSelection"
                                                 [intention]="orderingContext()?.intention"
                                                 [filteredOrderType]="orderType()"
                                                 (onStoreDetails)="showStoreDetails(store)"
                                                 (onOrderFromStore)="selectContext(store, $event)"></woa-store-details-panel>
                    }
                }
                @if (!filteredAllStores.length) {
                    @if (location()) {
                        <div class="stores-no-stores" id="no-stores-in-location-message">
                            {{ noStoresInLocationMessage() | translate: ({location: location().location}) }}
                        </div>
                    } @else {
                        <div class="stores-no-stores" id="no-stores">
                            {{ 'woa.message.ordering-context.noStores' | translate }}
                        </div>
                    }
                }
            </div>
        }
    }
    @if (showTableSelection() && !showTableOptions() && tableSelectionMethod() === TableLookupMethod.MANUAL && !selectedStoreForTable() && !selectedTable()) {
        <woa-button woa-page-footer-control
                    id="button-lookup" [label]="'woa.button.ordering-context.acceptTableNumber'"
                    (onActivate)="form()?.submit()"></woa-button>
    }
    @if (showDeliveryAddressEntry()) {
        <woa-button woa-page-footer-control
                    id="delivery-address-entry-confirm-button" [label]="deliveryAddressConfirmLabel()"
                    (onActivate)="form()?.submit()"></woa-button>
    }
</woa-modal-page-layout>
